import { Button, Flex, SvgIcon } from '@volue/wave-react';
import { circle as Circle, featureGroup as FeatureGroup } from 'leaflet';
import type { Layer } from 'leaflet';
import React, { useContext, useEffect, useState } from 'react';
import { useMap } from 'react-leaflet';

import { SplitViewContext } from '../../SplitView/SplitViewContext';
import { ButtonGroup } from './ButtonGroup';

export function ZoomController() {
  const map = useMap();
  const [locationLayer, setLocationLayer] = useState<Layer>();
  const viewState = useContext(SplitViewContext);

  useEffect(() => {
    if (!map) {
      return;
    }
    map.doubleClickZoom.disable();
  }, [map]);

  const toggleLocation = () => {
    if (locationLayer && map.hasLayer(locationLayer)) {
      map.removeLayer(locationLayer);
      setLocationLayer(undefined);
    } else {
      map?.locate({
        setView: true
      });
      map?.once('locationfound', location => {
        const group = FeatureGroup();
        Circle(location.latlng, location.accuracy).addTo(group);
        setLocationLayer(group);
        map.addLayer(group);
      });
    }
  };

  return (
    <Flex
      gap="spacingXs"
      flow="column"
      css={{
        position: 'absolute',
        bottom: '1rem',
        right: '1rem',
        zIndex: '400',
        '@mqMediumAndBelow': {
          bottom: viewState === 'TextPanelOverMap' ? '4.5rem' : '1rem'
        }
      }}
    >
      <ButtonGroup
        css={{
          '@mqMediumAndBelow': {
            display: 'none'
          }
        }}
        buttons={[
          {
            props: {
              variant: 'outline',
              withLoneIcon: true,
              onClick: () => map?.zoomIn(),
              'aria-label': 'Zoom in',
              key: 'zoomIn'
            },
            children: <SvgIcon iconName="add" css={{ color: '$colorBlack' }} />
          },
          {
            props: {
              withLoneIcon: true,
              variant: 'outline',
              onClick: () => map?.zoomOut(),
              'aria-label': 'Zoom out',
              key: 'zoomOut'
            },
            children: (
              <SvgIcon iconName="minus" css={{ color: '$colorBlack' }} />
            )
          }
        ]}
      />
      <Button
        withLoneIcon
        variant="outline"
        onClick={() => toggleLocation()}
        aria-label="Locate"
        className="mHa"
      >
        <SvgIcon iconName="locate" css={{ color: '$colorBlack' }} />
      </Button>
    </Flex>
  );
}
